
import { tryFetchWithAuth } from 'utils/fetchWithAuth';

const fetchSearchResults = async (filters) => {
  console.log('Fetching data:', JSON.stringify(filters, null, 2));
  try {
    const { data, error } = await tryFetchWithAuth('/search', {
      method: 'POST',
      body: JSON.stringify(filters),
    });

    // tryFetchWithAuth already logs and normalizes API/network errors
    if (error) {
      return { data: null, error };
    }

    return { data, error: null };
  } catch (error) {
    return { data: null, error: error.message };
  }
};

export default fetchSearchResults;